import { useCallback } from 'react';
import { useMutation, gql } from '@apollo/react-hooks';
import { get, pick } from 'lodash';
import type { UpdateAssetMutation, Asset } from '#/graphql/types';
import { updateAsset } from '#/graphql/mutations';
import fields from '../utils/mutationDataFields';
import { GET_ASSET } from './useAssetQuery';

const q = gql(updateAsset);

const useAssetUpdate = () => {
  const [mutation, result] = useMutation<UpdateAssetMutation>(q);
  const updateAsset = useCallback(
    async (itemId: string, asset: Asset) => {
      const response = await mutation({
        variables: {
          id: itemId,
          data: pick(asset, fields),
        },
        refetchQueries: [{ query: GET_ASSET, variables: { id: itemId } }],
        awaitRefetchQueries: true,
      });

      return get(response, 'data.updateAsset', undefined);
    },
    [mutation],
  );

  return { updateAsset, result };
};

export default useAssetUpdate;
